export default "__VITE_ASSET__3a34a99b__"